import { Observable } from '../Observable';
export function finalize(callback) {
    return function (source) {
        return new Observable(function (subscriber) {
            source.subscribe(subscriber);
            subscriber.add(callback);
        });
    };
}
//# sourceMappingURL=finalize.js.map